import { API_URL } from '../../../../../../../actions/utilAction';
import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrlForCustomAPI,
  downloadFilesOnAPICall,  
  extractDataFromObject,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../../../actions/utilAction';

export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrlForCustomAPI,
  create_post_data,
  downloadFilesOnAPICall,
  showSuccessMessage,
  showErrorMessage,
  extractDataFromObject,
  API_URL,
  showWarningMessage,
};



export const GET_PATIENT_APPOINTMENT_LIST_FOR_AGENCY = `${API_URL}/api/PatientAppointments/GetPatientAppointmentListForParentPortal`;
export const GET_PATIENT_APPOINTMENT_LIST_FOR_SIGNATUREONLY_FOR_AGENCY = `${API_URL}/api/PatientAppointments/GetPatientAppointmentListForSignatureOnlyForParentPortal`;
export const POST_BATCHENCOUNTERGUARDIANSIGNATURES = `${API_URL}/patient-encounter/SaveBatchEncounterGuardianSignatures`;
export const POST_BATCHENCOUNTERGUARDIANSIGNATURESANDCOMPLETE = `${API_URL}/patient-encounter/SaveBatchEncounterGuardianSignaturesAndComplete`;

export const  manageAppointmentsActionTypes = {
  get_patient_appointment_list: createRequestActionTypes('GET_PATIENT_APPOINTMENT_LIST'),
  post_saveBatchEncounterGuardianSignatures: createRequestActionTypes('POST_BATCHENCOUNTERGUARDIANSIGNATURES'),
  post_saveBatchEncounterGuardianSignaturesAndComplete: createRequestActionTypes('POST_BATCHENCOUNTERGUARDIANSIGNATURESANDCOMPLETE'),
};



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/containers/ManageAppointments/components/appointments/constants/ApiConstants.js